import React, { useRef } from 'react';
import { useOnClickOutside } from 'usehooks-ts';
import PopupContent from '~/components/common/popup/styles';

interface CustomPopupProps {
    id: string;
    onClickOutside?: () => void;
    children: React.ReactNode;
    isVisible: boolean;
}

const CustomPopup = ({ id, onClickOutside, children, isVisible }: CustomPopupProps) => {
    const ref = useRef<HTMLDivElement>(null);

    useOnClickOutside(ref as React.RefObject<HTMLElement>, () => {
        if (isVisible && onClickOutside) {
            onClickOutside();
        }
    });

    return (
        <PopupContent
            id={id}
            style={{
                visibility: isVisible ? 'visible' : 'hidden',
            }}
            ref={ref}
            role="dialog"
            aria-hidden={!isVisible}
        >
            {children}
        </PopupContent>
    );
};

export default CustomPopup;
